import commonModels from './config/commonModels';

export default commonModels;
